import {DashedEdge} from '../Edge/components/DashedEdge';
import {RaisedEdge} from '../Edge/components/RaisedEdge';

export const edgeTypes = {
  dashed: DashedEdge,
  raised: RaisedEdge,
};
